import React from 'react';
import { Typography, Box, Button, Container } from '@mui/material';
import ageroContent from '../../data/agero-content.json';
import { useOrg } from '../../context/OrgContext';

const HeroSection = ({ content, imageUrl }) => {
  const hero = content || ageroContent.hero; // a partner passes its own copy
  const { name } = useOrg();
  // Function to scroll to application form
  const scrollToApplicationForm = () => {
    const applicationFormSection = document.getElementById('application-form-section');
    if (applicationFormSection) {
      applicationFormSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <Box 
      sx={{ 
        p: { xs: 4, md: 6 }, 
        textAlign: 'center', 
        backgroundColor: '#f5f5f5',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <Container maxWidth="lg">
        {/* Hero Content */}
        <Box sx={{ position: 'relative', zIndex: 2 }}>
          <Typography 
            variant="h2" 
            component="h1" 
            gutterBottom
            sx={{ 
              fontWeight: 'bold',
              mb: 3,
              color: 'primary.main' // the company's primary color
            }}
          >
            {hero.title}
          </Typography>
          
          <Typography 
            variant="h5" 
            sx={{ 
              mb: 4,
              maxWidth: '800px',
              mx: 'auto'
            }}
          >
            {hero.subtitle}
          </Typography>
          
          <Button
            variant="contained"
            size="large"
            onClick={scrollToApplicationForm}
            sx={{
              py: 1.5,
              px: 4,
              fontSize: '1.1rem',
              textTransform: 'none'
            }}
          >
            {hero.cta}
          </Button>
        </Box>
        
        {/* Hero Image */}
        <Box
          component="img"
          src={imageUrl || '/images/hero-image.jpg'}
          alt={`${name} Hero`}
          sx={{
            mt: 4,
            width: '100%',
            height: '300px',
            objectFit: 'cover',
            objectPosition: 'center 30%', // Adjust to show faces better
            borderRadius: 2
          }}
        />
      </Container>
    </Box>
  );
};

export default HeroSection;
